module.exports = __webpack_public_path__ + "static/avg_rental_price-d592f5d002edfb5fc97969fb96bf572e.png";